const BattleCalc = require('./BattleCalc');

const StatRecovery = (options) => {
  try {
    const { allUnits, initPaused, unitAPFullCallback, logger } = options;

    let _runTime;
    let _deltaTimeSecs = 0.1;
    let _lastUpdate = new Date().getTime();

    let _allUnits = allUnits;
    let _paused = initPaused;

    let _done = false;

    const updateUnit = (unit, deltaTimeSecs) => {
      try {
        const regen = unit.attributes.regeneration * 2;
        const speed = unit.attributes.speed * 2;
        const mg = unit.attributes.magicalGravity * 2;

        const slowed = BattleCalc.getCondition(unit, 'slowed');
        const apGain = deltaTimeSecs * speed * (slowed ? 0.5 : 1.0);

        unit.hp = Math.min(unit.max_hp, unit.hp + deltaTimeSecs * regen);
        unit.ap = Math.min(unit.max_ap, unit.ap + apGain);
        unit.mp = Math.min(unit.max_mp, unit.mp + deltaTimeSecs * mg);
      } catch (err) {
        logger.logError(err, {
          module: 'StatRecovery',
          func: 'updateUnit',
          unit,
          deltaTimeSecs,
        });
      }
    };

    const update = () => {
      try {
        if (_paused || _done) {
          return;
        }

        _runTime = Date.now();
        _deltaTimeSecs = (_runTime - _lastUpdate) * 0.001;
        _lastUpdate = _runTime;

        for (const unit of Object.values(_allUnits)) {
          updateUnit(unit, _deltaTimeSecs);

          if (unit.ap >= unit.max_ap) {
            unitAPFullCallback(unit);
          }
        }
      } catch (err) {
        logger.logError(err, {
          module: 'StatRecovery',
          func: 'update',
        });
      }
    };
    const _updateInterval = setInterval(update, 20);

    return {
      setUnits: (units) => {
        _allUnits = units;
      },
      pause: () => {
        _paused = true;
      },
      resume: () => {
        _paused = false;
        _lastUpdate = Date.now();
      },
      dispose: () => {
        _done = true;
        clearInterval(_updateInterval);
      },
    };
  } catch (err) {
    options.logger.logError(err, {
      module: 'StatRecovery',
      func: 'constructor',
      options,
    });
  }
};
module.exports = StatRecovery;
